@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../../constants/spacing.module.less';

.product-list-container {
  margin-top: @space-8;
}

.product-list-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: @space-8;
  gap: @space-8;
  font-size: 12px;
}

.clear-all-button {
  display: flex;
  align-items: center;
  padding: @space-0;
  margin: @space-0;
  height: auto;
  color: var(--blue-600, #006fbb);

  .clear-icon {
    width: 12px;
    display: flex;
    align-items: center;
    margin-right: @space-8;
  }

  .clear-text {
    display: flex;
    padding-left: @space-8;
  }
}

.product-table {
  border: 1px solid var(--grey-300);
}

.empty-row-text {
  padding: @space-40 @space-0;
  align-self: stretch;
  color: var(--grey-600);
  text-align: center;
}

.product-list-footer {
  justify-content: space-between;
  padding-top: @space-8;
  color: var(--grey-900);
  font-size: 12px;
}

.ordered-total {
  padding-right: @space-16;
}

.ordered-total-label {
  font-weight: 600;
  font-size: 14px;
}

.ordered-total-value {
  font-weight: 600;
  font-size: 14px;
}
